import { c as _c } from "react/compiler-runtime";
import { useAssociatedLinearIssue } from '@/data/linear/use-associated-issue';
import { useLinearIntegration } from '@/data/linear/use-linear-integration';

/**
 * The Linear issue linked to a pull request, with the connection gating the PR page sidebar and
 * the /code PR tab share. Null while the installation has no Linear connection; the linked-issue
 * request waits for the connection.
 */
export function useLinkedLinearIssue(t0) {
  const $ = _c(5);
  const {
    owner,
    repo,
    pullNumber,
    installationId
  } = t0;
  const {
    connection
  } = useLinearIntegration(installationId ?? undefined);
  const connectionId = connection?.nangoConnectionId;
  const t1 = !!connectionId;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      enabled: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const associatedIssue = useAssociatedLinearIssue(owner, repo, pullNumber, t2);
  if (!connectionId || !installationId) {
    return null;
  }
  let t3;
  if ($[2] !== associatedIssue || $[3] !== installationId) {
    t3 = {
      ...associatedIssue,
      installationId
    };
    $[2] = associatedIssue;
    $[3] = installationId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}